import { useQuery } from '@tanstack/react-query';
import apiClient from '../services/apiService';

export const useDashboardData = () => {
  return useQuery({
    queryKey: ['dashboardData'],
    queryFn: async () => {
      const response = await apiClient.get('/api/dashboard-data');
      return {
        totalBookings: response.total_bookings,
        allCustomers: response.all_customers,
        allProperties: response.all_properties,
        totalRevenue: response.total_revenue,
      };
    },
    staleTime: 5 * 60 * 1000,
  });
};
